
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class OnboardingWelcome extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  MFATypes!: string[];

  selectOption(key: string) {
    if (this.MFATypes.includes(key)) {
      this.$emit('choice', key);
    }
  }
}
